import { create } from "zustand";
import { api } from "network/network";
import { APIendpoints, DefaultParams } from "utils/constants/APIendpoints";
import { devtools } from "zustand/middleware";
import { API_HOST_WMS } from "config/api.config";
import { makeEncodedQueryParams } from "operations/operations";
import _get from "lodash-es/get";
import { SELLER_STATUS_APPROVED, STATUS_BEGIN, STATUS_DONE, STATUS_FAIL } from "utils/constants/others";

let useCommonStore = create(
  devtools((set, get) => ({
    uploadDocumentStatus: "",
    uploadedDocumentUrl: "",
    error: "",
    cities: [],
    getAllCitiesStatus: "",

    uploadDocument: async (formData, id, successCallback) => {
      set({ uploadDocumentStatus: STATUS_BEGIN });
      api
        .post(API_HOST_WMS, APIendpoints.uploadDocument, formData)
        .then((response) => {
          set({
            uploadedDocumentUrl: _get(
              response,
              ["data", "response", "response"],
              {}
            ),
          });
          set({ uploadDocumentStatus: STATUS_DONE });

          successCallback(id, get().uploadedDocumentUrl)

        })
        .catch((error) => {
          set({
            error: _get(error, ["response", "data", "error"], {}),
          });
          set({ uploadDocumentStatus: STATUS_FAIL });
        });
    },

    resetUploadedDocument: () => {
      set({ uploadedDocumentUrl: null });
    },

    uploadLogoutStateDocument: async (formData, successCallback) => {
      set({ uploadDocumentStatus: STATUS_BEGIN });
      api
        .post(API_HOST_WMS, APIendpoints.uploadLogOutStateDocument, formData)
        .then((response) => {
          set({
            uploadedDocumentUrl: _get(
              response,
              ["data", "response", "response"],
              {}
            ),
          });
          set({ uploadDocumentStatus: STATUS_DONE });
          successCallback()
          // successCallback(id, get().uploadedDocumentUrl)

        })
        .catch((error) => {
          set({
            urlUploadData: {
              message: error?.response?.data?.error?.message,
              type: 'error'
            }
          });
          set({
            error: _get(error, ["response", "data", "error"], {}),
          });
          set({ uploadDocumentStatus: STATUS_FAIL });
        });
    },

    uploadDocs: async (formData, success_callback) => {
      set({ uploadDocumentStatus: STATUS_BEGIN });
      api
        .post(API_HOST_WMS, APIendpoints.uploadDocument, formData)
        .then((response) => {
          set({
            uploadedDocumentUrl: _get(
              response,
              ["data", "response", "response"],
              {}
            ),
          });
          set({ uploadDocumentStatus: STATUS_DONE });
          if (typeof (success_callback) === "function") {
            success_callback(_get(
              response,
              ["data", "response", "response"],
              {}
            ));
          }
        })
        .catch((error) => {
          set({
            error: _get(error, ["response", "data", "error"], {}),
          });
          set({ uploadDocumentStatus: STATUS_FAIL });
        });
    },

    uploadOrderBillDocument: async (formData, updatePurchaseOrder, param, poId) => {
      set({ uploadDocumentStatus: STATUS_BEGIN });
      api
        .post(API_HOST_WMS, APIendpoints.uploadDocument, formData)
        .then((response) => {
          set({
            uploadedDocumentUrl: _get(
              response,
              ["data", "response", "response"],
              {}
            ),
          });
          set({ uploadDocumentStatus: STATUS_DONE });

          updatePurchaseOrder({
            id: poId,
            supplier_bill_number: param.invoice_number,
            total_supplier_bill_amount: parseFloat(param.invoice_amount),
            supplier_bill_image: get().uploadedDocumentUrl,
            supplier_bill_date: param.invoice_date,
            is_custom_shipping_address_required: param.is_custom_shipping_address_required,
            shipping_address: param.shipping_address_line1,
            shipping_city: param.shipping_city,
            shipping_pincode: parseInt(param.shipping_pincode),
          })

        })
        .catch((error) => {
          set({
            error: _get(error, ["response", "data", "error"], {}),
          });
          set({ uploadDocumentStatus: STATUS_FAIL });
        });
    },

    uploadFileToS3: async (file, preSignedUrl, success_callback, error_callback, metadata) => {
      try {
        const response = await fetch(preSignedUrl, {
          method: "PUT",
          body: file,
          headers: {
            ...metadata,
            "Content-Type": file?.type,
          },
        });

        if (response.ok) {
          success_callback()
        } else {
          error_callback();
        }
      } catch (err) {
        error_callback();
      }
    },

    getAllCities: async () => {
      set({ getAllCitiesStatus: STATUS_BEGIN });
      api
        .get(API_HOST_WMS, APIendpoints.getAllCities)
        .then((response) => {
          const cityList = _get(response, ["data", "response", "cities"], []);
          set({ cities: cityList, getAllCitiesStatus: STATUS_DONE });
        })
        .catch((error) => {
          set({
            error: _get(error, ["response", "data", "error"], {}),
            getAllCitiesStatus: STATUS_FAIL,
          });
        });
    },
  }))
);

export default useCommonStore;